import {Actions} from '@redstack/shared'
import {createFileRoute} from '@tanstack/react-router'
import {SettingsPage} from '@/features/settings/SettingsPage'
import {useRequirePermission} from '@/hooks/useRequirePermission'

function SettingsRoute() {
	if (!useRequirePermission(Actions.SETTINGS_MANAGE)) return null
	return <SettingsPage />
}

export const Route = createFileRoute('/settings/')({
	component: SettingsRoute,
})
